export function cx(base: string, override?: string): string {
  return override ? `${base} ${override}` : base;
}
